(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mobileFacetsBottomBarBound) return;
    window.__mobileFacetsBottomBarBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-mobile-sort-trigger]') : null;
      if (!(trigger instanceof HTMLElement)) return;

      const section = trigger.closest('.shopify-section');
      const sortTargetId = trigger.dataset.sortTarget;
      if (!section || !sortTargetId) return;

      const drawer = section.querySelector('#filters-drawer');
      const targetDetails = section.querySelector(`#${CSS.escape(sortTargetId)}`);

      const openTarget = () => {
        if (targetDetails instanceof HTMLDetailsElement) {
          targetDetails.open = true;
          const summary = targetDetails.querySelector('summary');
          if (summary instanceof HTMLElement) summary.focus();
        }
      };

      if (drawer instanceof HTMLElement && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        window.setTimeout(openTarget, 180);
      } else {
        openTarget();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
